import { studentHomeApi } from '@mathflat/domain/StudentHome'
import { action, computed, makeObservable, observable } from 'mobx'

import { commonRepo } from '~/@common/services/repo.service.ts'

import RecentChallenge from '../@common/model/RecentChallenge'

// const delay = () => new Promise((resolve) => setTimeout(resolve, 3000))

export default class RecentChallengeService {
  private _recentChallenges?: RecentChallenge[]
  private _recentChallengeIndex?: number
  private _isArithmetic = false

  constructor() {
    makeObservable<this, '_recentChallenges' | '_recentChallengeIndex' | '_isArithmetic'>(this, {
      _recentChallenges: observable.ref,
      _recentChallengeIndex: observable,
      _isArithmetic: observable,
      recentChallenge: computed,
      isReady: computed,
      setRecentChallengeIndex: action,
      setRecentChallenges: action,
      setIsArithmetic: action,
    })
  }

  /** 표기뿐 아니라 시작 트랙까지 이 값으로 갈리므로, 권한은 여기 한 곳에서 잠근다 */
  get isArithmetic() {
    return this._isArithmetic && commonRepo.permission.byFeature.isAllowed('ARITHMETIC_WORKSHEET')
  }

  get recentChallenges() {
    return this._recentChallenges
  }

  get recentChallengeIndex() {
    return this._recentChallengeIndex
  }

  get recentChallenge() {
    if (this._recentChallenges && this._recentChallengeIndex !== undefined) {
      return this._recentChallenges[this._recentChallengeIndex]
    }
    return
  }

  get isReady() {
    return this._recentChallenges !== undefined
  }

  async loadRecentChallenges() {
    const data = await studentHomeApi.getRecentChallenge()
    if (!data) {
      this.setIsArithmetic(false)
      this.setRecentChallenges([])
      this.setRecentChallengeIndex(undefined)
      return
    }

    this.setIsArithmetic(data.default.isArithmetic ?? false)

    let challengeIndex: number | undefined = data.contents.findIndex(
      (item) => item.littleChapterId === data.default.littleChapterId,
    )
    if (challengeIndex === -1) {
      challengeIndex = data.contents.length ? 0 : undefined
    }
    this.setRecentChallengeIndex(challengeIndex)
    this.setRecentChallenges(data.contents.map((dto) => new RecentChallenge(dto)))
  }

  setRecentChallenges(data: RecentChallenge[]) {
    this._recentChallenges = data
  }

  setRecentChallengeIndex(value: number | undefined) {
    this._recentChallengeIndex = value
  }

  setIsArithmetic(value: boolean) {
    this._isArithmetic = value
  }
}
